<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :detailsComponent="componentForDetails"
      :delete_url="delete_url"
      :urls="urls"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import AddItem from "@/own/components/warehouseManagement/inventoryAdjustments/AddItem.vue";
import EditItem from "@/own/components/warehouseManagement/inventoryAdjustments/EditItem";
import Details from "@/own/components/warehouseManagement/inventoryAdjustments/Details";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/inventoryAdjustment.module";
export default {
  name: "InventoryAdjustment",
  components: { DataTable },
  data: () => ({
    componentForEditing: EditItem,
    componentForAdding: AddItem,
    componentForDetails: Details,
    delete_url: `${process.env.VUE_APP_BASE_URL}/warehouse_management/inventory_adjustments/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getINVENTADJUSTTableFilters",
      getTableState: "getINVENTADJUSTTableState",
      getTableData: "getINVENTADJUSTTableData",
      getTableHeaders: "getINVENTADJUSTTableHeaders",
      getTableProperties: "getINVENTADJUSTTableProperties",
      getTableExportUrl: "getINVENTADJUSTExportUrl",
      getTablePermissions: "getINVENTADJUSTTablePermissions",
      // getUploadType: "getINVENTADJUSTUploadType",
    },
    urls: {
      approve: `/warehouse_management/inventory_adjustments/approve`,
      delete: `/warehouse_management/inventory_adjustments/destroy`,
      complete: `/warehouse_management/inventory_adjustments/complete`,
      cancel: `/warehouse_management/inventory_adjustments/cancel`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
